export default "__VITE_ASSET__C9hpb5w2__"